import ApiService from '@/services/api.service';
import getters from '@/store/global';
import store from '@/store';

const state = {
    videos: [],
    count: '',
    next: '',
    prev: '',
    errors: {},
    details: {},
    isAlbum: false,
    albumIsUpdated: false
};

getters['fetchVideos'] = function(state) { return state.videos;}
getters['fetchVideoDetails'] = function(state) { return state.details;}
getters['fetchVideosCount'] = function(state) { return state.count;}
getters['fetchVideosNext'] = function(state) { return state.next;}
getters['fetchVideosPrev'] = function(state) { return state.prev;}
getters['fetchVideoAlbumIsUpdated'] = function(state) { return state.albumIsUpdated;}

const actions = {
    getAll(context, payload) {
        return ApiService
            .get('profile/' + payload + '/videos/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VIDEOS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_VIDEOS', []);
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getAlbum(context, payload) {
        return ApiService
            .get('video_albums/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VIDEOS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_VIDEOS', []);
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getDetails(context, payload) {
        return ApiService
            .get('videos/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_DETAILS', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_DETAILS', {});
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_VIDEOS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getPrev(context) {
        return ApiService
            .get(context.state.prev)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_VIDEOS_PREV', response.data.results);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    create(context, payload) {
        return ApiService
            .post('videos/create/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_NEW_VIDEOS', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    delete(context, payload) {
        return ApiService
            .put('videos/remove/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_VIDEOS', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    like(context, payload) {
        return ApiService
            .get('videos/' + payload + '/like/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VOTES', response.data);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    dislike(context, payload) {
        return ApiService
            .get('videos/' + payload + '/dislike/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VOTES', response.data);
            })
            .catch((response) => {
                if(response.status === 400 || response.status === 403){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    update(context, payload) {
        return ApiService
            .patch('videos/update/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('UPDATE_VIDEOS', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    updateDescription(context, payload) {
        return ApiService
            .patch('videos/update/', payload)
            .then(() => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setIsAlbum(context, payload) {
        context.commit('SET_IS_ALBUM', payload);
    }
};

const mutations = {
    SET_VIDEOS(state, videos) {
        state.videos = {};
        for (let i in videos) {
            state.videos[i] = videos[i];
        }
        state.errors = {};
    },
    ADD_VIDEOS(state, videos) {
        let total = state.count;
        let currentCount = Object.keys(state.videos).length;
        if (total == currentCount) {
            state.next = '';
            state.prev = '';
            return;
        }
        let firstEmpty;
        for (let i = 0; i < total; i++) {
            if (!state.videos[i]) {
                firstEmpty = parseInt(i);
                break;
            }
        }
        for (let j in videos) {
            state.videos[firstEmpty + parseInt(j)] = videos[j];
        }
        state.errors = {};
    },
    ADD_VIDEOS_PREV(state, videos) {
        let total = state.count;
        let currentCount = Object.keys(state.videos).length;
        if (total == currentCount) {
            state.next = '';
            state.prev = '';
            return;
        }
        let lastEmpty;
        for (let i = total; i > 0; i--) {
            if (!state.videos[i - 1]) {
                lastEmpty = i;
                break;
            }
        }
        let prevCount = videos.length;
        for (let j = 0; j < prevCount; j++) {
            state.videos[lastEmpty - prevCount + j] = videos[j];
        }
        state.errors = {};
    },
    ADD_NEW_VIDEOS(state, videos) {
        state.count += videos.length;
        let temp = Object.assign({}, state.videos);
        state.videos = {};
        for (let i in videos) {
            state.videos[i] = videos[i];
        }
        for (let j in temp) {
            state.videos[videos.length + parseInt(j)] = temp[j];
        }
        state.errors = {};
    },
    REMOVE_VIDEOS(state, videos) {
        let temp = Object.assign({}, state.videos);
        let count = 0;
        state.videos = {};
        for (let i in temp) {
            if (videos.indexOf(temp[i].id) == -1) {
                state.videos[count] = temp[i];
                count++;
            }
        }
        state.count -= videos.length;
        state.errors = {};
    },
    UPDATE_VIDEOS(state, updated) {
        if (!state.isAlbum) {
            if (updated[0].album) {
                state.albumIsUpdated = true;
                setTimeout(() => {
                    state.albumIsUpdated = false;
                }, 300);
            }
            return;
        }
        let removed = [];
        for (let i in updated) {
            if (updated[i].album) {
                removed.push(updated[i].id);
            }
        }
        if (removed.length == 0) {
            return;
        }
        state.count -= removed.length;
        let temp = Object.assign({}, state.videos);
        let count = 0;
        state.videos = {};
        for (let i in temp) {
            if (removed.indexOf(temp[i].id) == -1) {
                state.videos[count] = temp[i];
                count++;
            }
        }
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
                data.url +
                '?' +
                data.page_param +
                '=' +
                (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_PREV(state, data) {
        if (data.num_pages == 1) {
            state.prev = '';
            return;
        }
        if (data.page > 1) {
            state.prev =
                data.url +
                '?' +
                data.page_param +
                '=' +
                (data.page - 1);
        } else {
            state.prev =
                data.url +
                '?' +
                data.page_param +
                '=' +
                data.num_pages;
        }
        state.errors = {};
    },
    SET_VOTES(state, votes) {
        state.details.liked = votes.liked;
        state.details.disliked = votes.disliked;
        state.details.likes = votes.likes;
        state.details.dislikes = votes.dislikes;
        state.errors = {};
        store.dispatch('home/setVoted', [votes, 'videos']);
    },
    SET_DETAILS(state, details) {
        state.details = details;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
    SET_IS_ALBUM(state, isAlbum) {
        state.isAlbum = isAlbum;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
